import React from "react";
import {Button, Collapse, Dropdown, Menu, Popconfirm, Table, Typography} from "antd";
import {CopyOutlined, MoreOutlined} from "@ant-design/icons";

const {Text, Title} = Typography

export class FicheEmails extends React.Component {


    render() {
        const {selected, fiche} = this.props

        if (!selected) {
            return null
        }

        if (selected.emails.length === 0 || selected.parents.length > 0) {
            return null
        }


        const columns = [
            {
                render: (col, row) => {

                    const MENU = [
                        {
                            label: <a
                                onClick={() => fiche.modalAddEmail.show(selected.id, row, selected.adresses)}>Modifier</a>,
                            key: '0',
                        },
                        {
                            label: (
                                <Popconfirm
                                    title="Êtes-vous sûrs de vouloir supprimer cette adresse email ?"
                                    onConfirm={() => fiche.onDelete(row.id, "email")}
                                    okText="Oui"
                                    cancelText="Non"
                                    okType={"danger"}
                                >
                                    <Text type="danger">Supprimer</Text>
                                </Popconfirm>
                            ),
                            key: '1',
                        },
                    ]

                    return (
                        <Dropdown overlay={
                            <Menu
                                items={MENU}
                            />
                        } trigger={['click']}>
                            <Button type={"text"} icon={<MoreOutlined/>}/>
                        </Dropdown>
                    )
                }
            },
            {
                dataIndex: "email",
                render: (col, row) => (
                    <span>{row.type}: <a href={"mailto:" + col}>{row.email}</a></span>
                )
            },
            {
                width: "20px",
                render: (col, row) => {
                    return (
                        <Button size="small" shape={"circle"} icon={<CopyOutlined />} onClick={() => {navigator.clipboard.writeText(row.email)}}/>
                    )
                }
            },

        ]

        return (
            <Collapse style={{marginTop: 10}}>
                <Collapse.Panel header={"+" + selected.emails.length + " Email(s)"}>
                    <Table
                        columns={columns}
                        dataSource={selected.emails}
                        showHeader={false}
                        pagination={false}
                    />
                </Collapse.Panel>
            </Collapse>
        )
    }
}
